import React from 'react'
import PropTypes from 'prop-types'

import BasePressIcon from './PressIcon.base'

const TechCrunch = ({ className, ...props }) => (
  <BasePressIcon className={className} onClick={() => props.onClick('tech_crunch')} box='0 0 1700 300'>
    <g>
      <path d='M659.49,126.35v95.81h-35v-95.81h-35.36V95.85h105.73v30.49H659.49z' />
      <path d='M776.56,184.09h-55.57c1.08,10.46,7.21,15.15,16.06,15.15c8.3,0,15.16-1.81,24.54-6.68l12.45,20.75
        c-11.72,6.85-23.82,10.82-38.6,10.82c-28.51,0-44.21-20.21-44.21-49.26c0-32.65,18.4-49.43,43.3-49.43
        c25.98,0,42.22,17.14,42.22,52.32C776.75,180.47,776.75,182.46,776.56,184.09z M733.62,149.44c-7.4,0-11.55,5.05-12.63,14.43h27.07
        C746.43,154.31,743.18,149.44,733.62,149.44z' />
      <path d='M836.98,224.13c-27.78,0-44.38-17.68-44.38-49.61c0-29.05,14.8-49.08,45.1-49.08c17.86,0,28.15,8.3,36.45,21.65
        l-22.37,16.96c-4.51-8.3-7.58-12.27-14.61-12.27c-8.31,0-12.45,8.3-12.45,23.27c0,14.98,4.51,22.73,13.35,22.73
        c6.13,0,10.46-3.43,16.42-12.27l20.57,16.06C864.05,217.82,853.76,224.13,836.98,224.13z' />
      <path d='M947.74,222.15v-53.77c0-12.27-4.15-15.51-10.82-15.51c-6.86,0-11.01,3.25-11.01,15.15v54.13h-32.47V103.61l32.47-12.99
        v43.12c5.95-4.51,12.63-8.3,23.82-8.3c20.75,0,30.68,13.89,30.68,38.79v57.92H947.74z' />
      <path d='M1058.14,224.13c-37.53,0-57.56-27.79-57.56-65.13c0-40.59,23.82-65.13,57.74-65.13c31.04,0,43.31,13.35,51.97,37.17
        l-31.75,12.45c-4.52-11.73-8.84-19.13-20.39-19.13c-14.61,0-20.93,14.61-20.93,34.64c0,19.31,6.13,34.64,21.29,34.64
        c11,0,15.7-5.95,22.55-17.86l29.59,15.7C1102.16,208.08,1088.08,224.13,1058.14,224.13z' />
      <path d='M1190.53,163.15c-4.15-4.51-8.83-7.94-15.15-7.94c-7.94,0-12.82,3.79-12.82,15.33v51.6h-32.47v-94.73h32.47v6.86
        c5.59-5.41,11.91-8.84,20.21-8.84c6.85,0,11.55,1.62,15.33,3.97L1190.53,163.15z' />
      <path d='M1267.73,222.15v-6.32c-5.78,4.51-12.63,8.31-23.63,8.31c-20.75,0-30.68-13.89-30.68-38.8v-57.91h32.66v53.77
        c0,12.26,4.15,15.51,10.82,15.51c6.68,0,10.82-3.25,10.82-15.16v-54.12h32.66v94.73H1267.73z' />
      <path d='M1378.13,222.15v-53.77c0-12.27-4.15-15.51-10.82-15.51c-6.86,0-11.01,3.25-11.01,15.15v54.13h-32.47v-94.73h32.47v6.32
        c5.95-4.51,12.63-8.3,23.82-8.3c20.75,0,30.68,13.89,30.68,38.79v57.92H1378.13z' />
      <path d='M1474.08,224.13c-27.78,0-44.38-17.68-44.38-49.61c0-29.05,14.8-49.08,45.1-49.08c17.86,0,28.15,8.3,36.45,21.65
        l-22.37,16.96c-4.51-8.3-7.58-12.27-14.61-12.27c-8.31,0-12.45,8.3-12.45,23.27c0,14.98,4.51,22.73,13.35,22.73
        c6.13,0,10.46-3.43,16.42-12.27l20.57,16.06C1501.15,217.82,1490.86,224.13,1474.08,224.13z' />
      <path d='M1584.84,222.15v-53.77c0-12.27-4.15-15.51-10.82-15.51c-6.86,0-11.01,3.25-11.01,15.15v54.13h-32.47V103.61l32.47-12.99
        v43.12c5.95-4.51,12.63-8.3,23.82-8.3c20.75,0,30.68,13.89,30.68,38.79v57.92H1584.84z' />
    </g>
    <g>
      <polygon points='82.5,41.77 82.5,113.92 154.65,113.92 154.65,258.23 226.81,258.23 226.81,113.92 298.96,113.92 298.96,41.77  ' />
      <polygon points='371.11,186.08 371.11,113.92 298.96,113.92 298.96,258.23 515.42,258.23 515.42,186.08  ' />
      <rect x='371.11' y='41.77' width='144.31' height='72.15' />
    </g>
  </BasePressIcon>
)

TechCrunch.propTypes = {
  className: PropTypes.string
}

export default TechCrunch



// WEBPACK FOOTER //
// ./src/core/icons/press/TechCrunch.base.js